import { Component, OnInit } from '@angular/core';
import { DspaceStatistics } from '../../models/dspace-statistics';
import { DspaceStatisticsService } from '../../services/dspace-statistics-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-dspace-statistics',
  templateUrl: './add-dspace-statistics.component.html',
  styleUrls: ['./add-dspace-statistics.component.scss']
})
export class AddDspaceStatisticsComponent implements OnInit {
  model = {} as DspaceStatistics;
  isEdit = false;
  isLoading: boolean = false;

  constructor(
    private service: DspaceStatisticsService,
    private diagRef: NbDialogRef<AddDspaceStatisticsComponent>,
    private toast: NbToastrService,
    private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
  }

  save(){
    this.isLoading = true;
    this.service.post(this.model).subscribe((res) => {
      this.isLoading = false;
      this.diagRef.close('true');
      this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  update(){
    this.isLoading = true;
    this.service.put(this.model.id, this.model).subscribe((res) => {
      this.isLoading = false;
      this.diagRef.close('true');
      this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  close() {
    this.diagRef.close();
  }

}
